import React, { useState, useEffect } from "react";
import './nav.css';
import logo from '../website pic/Dlogo.png';


function Nav({ scrollToSection, refs }) {
    const [menuOpen, setMenuOpen] = useState(false);
    const [showLogo, setShowLogo] = useState(false);
// hamburger bar
    const handleToggle = () => setMenuOpen(prev => !prev);

    const handleClick = (ref) => {
        scrollToSection(ref);
        setMenuOpen(false);
    };

    useEffect(() => {
        const observer = new IntersectionObserver(
            ([entry]) => {
                setShowLogo(!entry.isIntersecting);
            },
            { threshold: 0.6 }
        );

        if (refs.homeRef.current) {
            observer.observe(refs.homeRef.current);
        }

        return () => {
            if (refs.homeRef.current) {
                observer.unobserve(refs.homeRef.current);
            }
        };
    }, [refs.homeRef]);

    return (
        <nav className="navbar">
            <div className="navbar-top">
                {showLogo ? (
                    <img src={logo} alt="Logo" className="navbar-logo" />
                ) : (
                    <span className="navbar-brand">Dhunna</span>
                )}
                <button
                    className={`hamburger ${menuOpen ? 'hamburger-active' : ''}`}
                    onClick={handleToggle}
                    aria-label={menuOpen ? "Close navigation menu" : "Open navigation menu"}
                    aria-expanded={menuOpen}
                    aria-controls="primary-navigation"
                >
                    ☰
                </button>
            </div>
            <div id="primary-navigation" className={`navbar-nav ${menuOpen ? 'open' : ''}`}>
                <button className="nav-item" onClick={() => handleClick(refs.homeRef)}>Home</button>
                <button className="nav-item" onClick={() => handleClick(refs.aboutRef)}>About</button>
                <button className="nav-item" onClick={() => handleClick(refs.projectRef)}>Projects</button>
                <button className="nav-item" onClick={() => handleClick(refs.contactRef)}>Contact</button>
                <a className="nav-resume" href="/PublicResume.pdf" target="_blank" rel="noreferrer">Résumé</a>
            </div>
        </nav>
    );
}

export default Nav;
